import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../../components/layout/LoadingScreen';

/**
 * Wraps any route that requires authentication.
 * - While auth state is loading (rehydrating localStorage) shows a spinner.
 * - While IDE handoff ticket is pending, waits instead of bouncing to /login.
 * - If not authenticated, redirects to /login and preserves the intended path.
 * - If authenticated, renders children normally.
 */
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, handoffPending } = useAuth();
  const location = useLocation();

  if (loading || handoffPending) {
    return (
      <LoadingScreen
        message={handoffPending ? 'Connecting from Candor IDE…' : undefined}
        subtitle={handoffPending ? 'Transferring your secure session' : undefined}
      />
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
